<template>
    <VSelect :placeholder="$t('CurrencySelect.selectCurrency')" :options="currencies" label="name"
             :value="selectedCurrency" @input="setSelectedCurrency" :clearable="clearable" :filter-by="filterBy">
        <template v-if="required" slot="search" slot-scope="{ attributes, events }">
            <input class="vs__search" :required="!selectedCurrencyAlpha3" v-bind="attributes" v-on="events"/>
        </template>
    </VSelect>
</template>

<script>
import { mapGetters } from "vuex";
import { filterBy } from "../../../helpers/VSelect";

export default {
    name: "CurrencySelect",
    props: {
        selectedCurrencyAlpha3: {
            required: true,
        },
        required: {
            type: Boolean,
            default: true,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters("currencies", {
            currencies: "currencies",
        }),
        selectedCurrency() {
            return this.currencies ? this.currencies.find(currency => currency.alpha3ISO === this.selectedCurrencyAlpha3) : null;
        },
    },
    methods: {
        setSelectedCurrency(currency) {
            this.$emit("setSelectedCurrency", currency);
        },
        filterBy,
    },
};
</script>

<style scoped>

</style>